import usePlatformBranding from '@/hooks/usePlatformBranding';

/** Loads platform favicon/branding on non-tenant pages (admin, landing, login). */
export default function PlatformBrandingEffect({ enabled }) {
  usePlatformBranding({ enabled });
  return null;
}
